
function reducer(state = [], action) {
    switch (action.type) {
        case 'INVITATION/SET':
            console.log({ reducer: action });
            return action.invitation;
        case 'INVITATION/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;